<template>
  <div class="d-flex">
    <div class="input-container flex-grow-1">
      <b-input
          v-model="searchTerm"
          @input="handleSearchInput"
          :placeholder="t('SEARCH')"
          :id="props.inputId"
          type="text"/>

      <loader :active="loaderActive"/>
    </div>

    <b-button variant="white" class="ml-2" @click="handleSearchButton" v-if="showButton">
      <img :src="iconSpyglass" :alt="t('SEARCH')"/>
    </b-button>
  </div>
</template>

<script setup lang="ts">
import iconSpyglass from "@/assets/icon/icon_spyglass.svg?inline";
import {ref} from "vue";
import {useI18n} from "vue-i18n";
import Loader from "@/components/Loader.vue";

const {t} = useI18n();
const searchTerm = ref("");
const searchTimer = ref(0);
const loaderActive = ref(false);

const props = withDefaults(defineProps<{
  onSearch: (searchValue: string) => Promise<any>;
  showButton?: boolean;
  minLength?: number;
  inputId?: string;
}>(), {
  showButton: true,
});

const handleSearchButton = async () => {
  if (!isSearchTermLongEnough()) {
    return;
  }

  loaderActive.value = true;
  await searchAndSetLoaderInactive();
};

const handleSearchInput = () => {
  if (!isSearchTermLongEnough()) {
    return;
  }

  if (searchTimer.value) {
    clearTimeout(searchTimer.value);
  }

  loaderActive.value = true;
  searchTimer.value = setTimeout(searchAndSetLoaderInactive, 500);
};

const searchAndSetLoaderInactive = async () => {
  try {
    await props.onSearch(searchTerm.value);
  } finally {
    loaderActive.value = false;
  }
};

const isSearchTermLongEnough = () => {
  return searchTerm.value.length >= (props.minLength || 0);
};

const shouldShowResults = () => {
  return isSearchTermLongEnough() && !loaderActive.value;
};

defineExpose({
  shouldShowResults,
});
</script>

<style lang="scss">
.input-container {
  position: relative;

  & > .loader-wrapper {
    position: absolute;
    right: 6px;
    top: 6px;
    height: 26px;
    width: 26px;

    & > div {
      border-width: 4px;
    }
  }
}
</style>
